import { Action } from "@ngrx/store";
import { Group } from "../../components/manage-insurance/components/groups/models/group.model";
import { NewGroup } from '../../components/manage-insurance/components/groups/models/add-group.model';

export const GET_GROUPS_LIST = '[Groups] Get Groups List';
export const GET_GROUPS_LIST_SUCCESS = '[Groups] Groups Groups List Success';
export const GET_GROUPS_LIST_FAIL = '[Groups] Groups Groups List Fail';
export const UPDATE_GROUP = '[Groups] Update Group';
export const UPDATE_GROUP_SUCCESS = '[Groups] Update Group Success';
export const UPDATE_GROUP_FAIL = '[Groups] Update Group Fail';
export const RESET_GROUP_CRUD = '[Groups] Reset CRUD';
export const ADD_GROUP = '[Group] Add New Group';
export const ADD_GROUP_SUCCESS = '[Group] Add New Group Success';
export const ADD_GROUP_FAIL = '[Group] Add New Group Fail';
export const DELETE_GROUP = '[Groups] Delete Group';
export const DELETE_GROUP_SUCCESS = '[Groups] Delete Group Success';
export const DELETE_GROUP_FAIL = '[Groups] Delete Group Fail';
export const CLEAR_GROUPS_LIST = '[Groups] Clear Groups List';

export class GetGroupsList implements Action {
    readonly type = GET_GROUPS_LIST;
    constructor(public payload: { institutionId: number } = null) { }
}

export class GetGroupsListSuccess implements Action {
    readonly type = GET_GROUPS_LIST_SUCCESS;
    constructor(public payload: any = null) { }
}

export class GetGroupsListFail implements Action {
    readonly type = GET_GROUPS_LIST_FAIL;
    constructor(public payload: any = null) { }
}

export class UpdateGroup implements Action {
    readonly type = UPDATE_GROUP;
    constructor(public payload: Group) { }
}

export class UpdateGroupSuccess implements Action {
    readonly type = UPDATE_GROUP_SUCCESS;
    constructor(public payload: Group) { }
}

export class UpdateGroupFail implements Action {
    readonly type = UPDATE_GROUP_FAIL;
    constructor(public payload: any = null) { }
}

export class AddGroup implements Action {
    readonly type = ADD_GROUP;
    constructor(public payload: any = null) { }
}

export class AddGroupSuccess implements Action {
    readonly type = ADD_GROUP_SUCCESS;
    constructor(public payload: Group = null) { }
}

export class AddGroupFail implements Action {
    readonly type = ADD_GROUP_FAIL;
    constructor(public payload: any = null) { }
}

export class DeleteGroup implements Action {
    readonly type = DELETE_GROUP;
    constructor(public payload: Group){}
  }

export class DeleteGroupSuccess implements Action {
    readonly type = DELETE_GROUP_SUCCESS;
    constructor(public payload: Group){}
  }

  export class DeleteGroupFail implements Action {
    readonly type = DELETE_GROUP_FAIL;
    constructor(public payload: any = null){}
  }

export class ResetGroupCRUD implements Action {
    readonly type = RESET_GROUP_CRUD;
    constructor(public payload: any = null) { }
}

export class ClearGroupsList implements Action {
    readonly type = CLEAR_GROUPS_LIST;
    constructor(public payload: any = null) { }
}

export type GroupsActions =
    | AddGroup
    | AddGroupSuccess
    | AddGroupFail
    | GetGroupsList
    | GetGroupsListSuccess
    | GetGroupsListFail
    | UpdateGroup
    | UpdateGroupSuccess
    | UpdateGroupFail
    | DeleteGroup
    | DeleteGroupSuccess
    | DeleteGroupFail
    | ResetGroupCRUD
    | ClearGroupsList
    ;